<div class="row" *ngIf="info">
    <div class="col-12 pt-2 pb-2 infoCont">
        <a href="perfil/{{id}}" class="usernameText">{{info.name}}</a>
        <div class="row">
            <div class="col-12 p-0">
                <span class="stat pl-3">
                    {{info.followerAmount}}
                    seguidores,
                </span>
                <span class="stat pl-2">
                    siguiendo
                    {{info.followingAmount}}
                </span>
            </div>
        </div>
    </div>
</div>